import { apiPost, apiPutNoContent } from "./http";

export interface LoginTokenResponse {
  accessToken: string;
  tokenType?: string;
  expiresIn?: number;
  /** 登录成功后的租户业务编号（与 JWT 一致；账号可能输的是 Code） */
  tenantLegacyId?: string;
  tenantName?: string;
}

export async function loginPlatform(password: string): Promise<LoginTokenResponse> {
  return apiPost<LoginTokenResponse>("/api/platform/login", { password });
}

export async function loginTenantSuperAdmin(tenantLegacyId: string, password: string): Promise<LoginTokenResponse> {
  return apiPost<LoginTokenResponse>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/super-admin/login`, {
    password,
  });
}

export async function loginTenantSuperAdminByAccount(account: string, password: string): Promise<LoginTokenResponse> {
  return apiPost<LoginTokenResponse>(`/api/tenants/super-admin/login`, {
    account,
    password,
  });
}

export async function changeTenantSuperAdminPassword(
  tenantLegacyId: string,
  oldPassword: string,
  newPassword: string,
): Promise<void> {
  await apiPutNoContent(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/super-admin/password`, {
    oldPassword,
    newPassword,
  });
}
